// extracted by mini-css-extract-plugin
export default {"loading":"skeletonList_loading__ljEhE"};